// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__13zt4","title":"Images90_title__gQq4L","images":"Images90_images__3eqiy"};